/* eslint-disable */

import { arrayToObject } from './common.js';

function makeFingerprint() {
  function toFloat(value) {
    return parseFloat(value);
  }

  function toInt(value) {
    return parseInt(value);
  }

  function replaceNaN(value, replacement) {
    return typeof value === 'number' && isNaN(value) ? replacement : value;
  }

  function boolToInt(fn) {
    return function() {
      return fn() ? 1 : 0;
    };
  }

  function getProcessors() {
    const processors = [],
      n = navigator,
      w = window,
      d = document;

    function addProcessor(key, handler) {
      processors.push({
        key: key,
        handler: handler,
      });
    }

    addProcessor('user_agent', function() {
      return n.userAgent;
    });

    addProcessor('screen_height', function() {
      return w.screen.height;
    });

    addProcessor('screen_width', function() {
      return w.screen.width;
    });

    addProcessor('java_enabled', function() {
      if (typeof n.javaEnabled != 'function') {
        return false;
      }

      return n.javaEnabled();
    });

    addProcessor('java_script_enabled', function() {
      return true;
    });

    addProcessor('language', function() {
      return (
        n.language ||
        n.userLanguage ||
        n.browserLanguage ||
        n.systemLanguage ||
        ''
      );
    });

    function getColorDepth() {
      return w.screen.colorDepth || -1;
    }

    addProcessor('screen_color_dept', getColorDepth);

    addProcessor('device_memory', function() {
      return replaceNaN(toFloat(n.deviceMemory), -1);
    });

    addProcessor('hardware_concurrency', function() {
      try {
        const concurrency = toInt(n.hardwareConcurrency);
        return isNaN(concurrency) ? 1 : concurrency;
      } catch (e) {
        return 1;
      }
    });

    addProcessor('resolution', function() {
      const dimensions = [toInt(w.screen.width), toInt(w.screen.height)];
      dimensions.sort().reverse();
      return dimensions;
    });

    addProcessor('available_resolution', function() {
      if (w.screen.availWidth && w.screen.availHeight) {
        const dimensions = [
          toInt(w.screen.availWidth),
          toInt(w.screen.availHeight),
        ];
        dimensions.sort().reverse();
        return dimensions;
      }
      return undefined;
    });

    function getTimezoneOffset() {
      // Since the DST season differs in the northern and the southern hemispheres,
      // both January and July timezones offsets are considered.

      const currentYear = new Date().getFullYear();

      return Math.max(
        toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()),
        toFloat(new Date(currentYear, 6, 1).getTimezoneOffset())
      );
    }

    addProcessor('timezone_offset', getTimezoneOffset);
    addProcessor('time_zone', getTimezoneOffset);

    addProcessor(
      'session_storage',
      boolToInt(function() {
        try {
          return !!w.sessionStorage;
        } catch (error) {
          /* SecurityError when referencing it means it exists */
          return true;
        }
      })
    );

    addProcessor(
      'local_storage',
      boolToInt(function() {
        try {
          return !!w.localStorage;
        } catch (e) {
          /* SecurityError when referencing it means it exists */
          return true;
        }
      })
    );

    addProcessor(
      'indexed_db',
      boolToInt(function() {
        try {
          return !!w.indexedDB;
        } catch (e) {
          /* SecurityError when referencing it means it exists */
          return true;
        }
      })
    );

    addProcessor(
      'open_database',
      boolToInt(function() {
        return !!w.openDatabase;
      })
    );

    addProcessor('cpu_class', function() {
      return w.cpuClass || 'unknown';
    });

    addProcessor('navigator_platform', function() {
      return navigator.platform || 'unknown';
    });

    addProcessor('regular_plugins', function() {
      if (!navigator.plugins) {
        return undefined;
      }

      const plugins = [];

      for (let i = 0; i < navigator.plugins.length; ++i) {
        const plugin = navigator.plugins[i];
        if (!plugin) {
          continue;
        }

        const mimeTypes = [];
        for (let j = 0; j < plugin.length; ++j) {
          const mimeType = plugin[j];
          mimeTypes.push([mimeType.type, mimeType.suffixes].join('~'));
        }

        plugins.push(
          [plugin.name, plugin.description, mimeTypes.join(',')].join('::')
        );
      }

      return plugins;
    });

    // addProcessor("canvas", function () {
    //   function makeCanvasContext() {
    //     const canvas = document.createElement("canvas");
    //     canvas.width = 240;
    //     canvas.height = 140;
    //     canvas.style.display = "inline";
    //     return [canvas, canvas.getContext("2d")];
    //   }

    //   function isSupported(canvas, context) {
    //     return !!(context && canvas.toDataURL);
    //   }

    //   function save(canvas) {
    //     return canvas.toDataURL();
    //   }

    //   function getCanvasFingerprint() {
    //     const [canvas, context] = makeCanvasContext();
    //     if (!isSupported(canvas, context)) {
    //       return { winding: false, data: "" };
    //     }

    //     // detect browser support of canvas winding
    //     // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    //     // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    //     context.rect(0, 0, 10, 10);
    //     context.rect(2, 2, 6, 6);
    //     const winding = !context.isPointInPath(5, 5, "evenodd");

    //     context.textBaseline = "alphabetic";
    //     context.fillStyle = "#f60";
    //     context.fillRect(125, 1, 62, 20);
    //     context.fillStyle = "#069";
    //     // https://github.com/Valve/fingerprintjs2/issues/66
    //     // this can affect FP generation when applying different CSS on different websites
    //     context.font = "11pt no-real-font-123";
    //     // the choice of emojis has a gigantic impact on rendering performance (especially in FF)
    //     // some newer emojis cause it to slow down 50-200 times
    //     // context.fillText("Cw爨m fjordbank \ud83d\ude03 gly", 2, 15)
    //     const printedText = "Cwm fjordbank \ud83d\ude03 gly";
    //     context.fillText(printedText, 2, 15);
    //     context.fillStyle = "rgba(102, 204, 0, 0.2)";
    //     context.font = "18pt Arial";
    //     context.fillText(printedText, 4, 45);

    //     // canvas blending
    //     // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    //     // http://jsfiddle.net/NDYV8/16/
    //     context.globalCompositeOperation = "multiply";
    //     context.fillStyle = "rgb(255,0,255)";
    //     context.beginPath();
    //     context.arc(50, 50, 50, 0, Math.PI * 2, true);
    //     context.closePath();
    //     context.fill();
    //     context.fillStyle = "rgb(0,255,255)";
    //     context.beginPath();
    //     context.arc(100, 50, 50, 0, Math.PI * 2, true);
    //     context.closePath();
    //     context.fill();
    //     context.fillStyle = "rgb(255,255,0)";
    //     context.beginPath();
    //     context.arc(75, 100, 50, 0, Math.PI * 2, true);
    //     context.closePath();
    //     context.fill();
    //     context.fillStyle = "rgb(255,0,255)";
    //     // canvas winding
    //     // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    //     // http://jsfiddle.net/NDYV8/19/
    //     context.arc(75, 75, 75, 0, Math.PI * 2, true);
    //     context.arc(75, 75, 25, 0, Math.PI * 2, true);
    //     context.fill("evenodd");

    //     return ["canvas winding:" + winding, "canvas fp:" + save(canvas)].join("~");
    //   }

    //   return getCanvasFingerprint();
    // });

    addProcessor('webgl_vendor', function() {
      function getWebglCanvas() {
        const e = document.createElement('canvas');

        let t;
        try {
          t = e.getContext('webgl') || e.getContext('experimental-webgl');
        } catch (e) {}

        return t;
      }

      try {
        const canvas = getWebglCanvas(),
          t = canvas.getExtension('WEBGL_debug_renderer_info');
        return (
          canvas.getParameter(t.UNMASKED_VENDOR_WEBGL) +
          '~' +
          canvas.getParameter(t.UNMASKED_RENDERER_WEBGL)
        );
      } catch (e) {
        return 'unknown';
      }
    });

    addProcessor('adblock', function() {
      if (d.body.hasOwnProperty('appendChild') && !d.body.appendChild) {
        return false;
      }

      const ads = d.createElement('div');
      ads.innerHTML = '&nbsp;';
      ads.className = 'adsbox';

      try {
        d.body.appendChild(ads);
        const node = d.querySelector('.adsbox');
        return !node || node.offsetHeight === 0;
      } finally {
        ads.parentNode && ads.parentNode.removeChild(ads);
      }
    });

    addProcessor('has_lied_languages', function() {
      if (n.languages != null) {
        try {
          if (n.languages[0].substr(0, 2) !== n.language.substr(0, 2))
            return true;
        } catch (e) {
          return true;
        }
      }
      return false;
    });

    addProcessor('has_lied_resolution', function() {
      return (
        w.screen.width < w.screen.availWidth ||
        w.screen.height < w.screen.availHeight
      );
    });

    addProcessor('has_lied_os', function() {
      let agent = n.userAgent.toLowerCase(),
        oscpu = n.oscpu,
        platform = n.platform.toLowerCase();

      const os = agent.indexOf('windows phone')
        ? 'Windows Phone'
        : 0 <= agent.indexOf('win')
        ? 'Windows'
        : 0 <= agent.indexOf('android')
        ? 'Android'
        : 0 <= agent.indexOf('linux')
        ? 'Linux'
        : 0 <= agent.indexOf('iphone') || 0 <= agent.indexOf('ipad')
        ? 'iOS'
        : 0 <= agent.indexOf('mac')
        ? 'Mac'
        : 'Other';

      const isMobile =
        'ontouchstart' in w || 0 < n.maxTouchPoints || 0 < n.msMaxTouchPoints;

      if (
        isMobile &&
        'Windows Phone' !== os &&
        'Android' !== os &&
        'iOS' !== os &&
        'Other' !== os
      )
        return true;

      if (oscpu != null) {
        oscpu = oscpu.toLowerCase();

        if (
          0 <= oscpu.indexOf('win') &&
          'Windows' !== os &&
          'Windows Phone' !== os
        )
          return true;

        if (0 <= oscpu.indexOf('linux') && 'Linux' !== os && 'Android' !== os)
          return true;

        if (0 <= oscpu.indexOf('mac') && 'Mac' !== os && 'iOS' !== os)
          return true;

        if (
          (-1 === oscpu.indexOf('win') &&
            -1 === oscpu.indexOf('linux') &&
            -1 === oscpu.indexOf('mac')) !==
          ('Other' === os)
        )
          return true;
      }

      if (
        0 <= platform.indexOf('win') &&
        'Windows' !== os &&
        'Windows Phone' !== os
      )
        return true;

      if (
        (0 <= platform.indexOf('linux') ||
          0 <= platform.indexOf('android') ||
          0 <= platform.indexOf('pike')) &&
        'Linux' !== os &&
        'Android' !== os
      )
        return true;

      if (
        (0 <= platform.indexOf('mac') ||
          0 <= platform.indexOf('ipad') ||
          0 <= platform.indexOf('ipod') ||
          0 <= platform.indexOf('iphone')) &&
        'Mac' !== os &&
        'iOS' !== os
      )
        return true;

      if (
        (-1 === platform.indexOf('win') &&
          -1 === platform.indexOf('linux') &&
          -1 === platform.indexOf('mac')) !==
        ('Other' === os)
      )
        return true;

      if (
        undefined === navigator.plugins &&
        'Windows' !== os &&
        'Windows Phone' !== os
      )
        return true;

      return false;
    });

    addProcessor('has_lied_browser', function() {
      const agent = n.userAgent.toLowerCase(),
        productSub = n.productSub;

      const browser =
        0 <= agent.indexOf('firefox')
          ? 'Firefox'
          : 0 <= agent.indexOf('opera') || 0 <= agent.indexOf('opr')
          ? 'Opera'
          : 0 <= agent.indexOf('chrome')
          ? 'Chrome'
          : 0 <= agent.indexOf('safari')
          ? 'Safari'
          : 0 <= agent.indexOf('trident')
          ? 'Internet Explorer'
          : 'Other';

      if (
        ('Chrome' === browser || 'Safari' === browser || 'Opera' === browser) &&
        '20030107' !== productSub
      )
        return true;

      const evalLength = eval.toString().length;

      if (
        37 === evalLength &&
        'Safari' !== browser &&
        'Firefox' !== browser &&
        'Other' !== browser
      )
        return true;

      if (
        39 === evalLength &&
        'Internet Explorer' !== browser &&
        'Other' !== browser
      )
        return true;

      if (
        33 === evalLength &&
        'Chrome' !== browser &&
        'Opera' !== browser &&
        'Other' !== browser
      )
        return true;

      let hasToSource;
      try {
        throw 'a';
      } catch (e) {
        try {
          e.toSource();
          hasToSource = true;
        } catch (e) {
          hasToSource = false;
        }
      }

      if (hasToSource && 'Firefox' !== browser && 'Other' !== browser)
        return true;

      return false;
    });

    addProcessor('touch_support', function() {
      let maxTouchPoints = 0;
      let touchEvent;
      if (n.maxTouchPoints !== undefined) {
        maxTouchPoints = toInt(n.maxTouchPoints);
      } else if (n.msMaxTouchPoints !== undefined) {
        maxTouchPoints = n.msMaxTouchPoints;
      }
      try {
        document.createEvent('TouchEvent');
        touchEvent = true;
      } catch (_) {
        touchEvent = false;
      }
      const touchStart = 'ontouchstart' in w;
      return [maxTouchPoints, touchEvent, touchStart];
    });

    addProcessor('js_fonts', function() {
      return new Promise((resolve) => {
        setTimeout(function() {
          var i = ['monospace', 'sans-serif', 'serif'],
            r = [
              'Andale Mono',
              'Arial',
              'Arial Black',
              'Arial Hebrew',
              'Arial MT',
              'Arial Narrow',
              'Arial Rounded MT Bold',
              'Arial Unicode MS',
              'Bitstream Vera Sans Mono',
              'Book Antiqua',
              'Bookman Old Style',
              'Calibri',
              'Cambria',
              'Cambria Math',
              'Century',
              'Century Gothic',
              'Century Schoolbook',
              'Comic Sans',
              'Comic Sans MS',
              'Consolas',
              'Courier',
              'Courier New',
              'Geneva',
              'Georgia',
              'Helvetica',
              'Helvetica Neue',
              'Impact',
              'Lucida Bright',
              'Lucida Calligraphy',
              'Lucida Console',
              'Lucida Fax',
              'LUCIDA GRANDE',
              'Lucida Handwriting',
              'Lucida Sans',
              'Lucida Sans Typewriter',
              'Lucida Sans Unicode',
              'Microsoft Sans Serif',
              'Monaco',
              'Monotype Corsiva',
              'MS Gothic',
              'MS Outlook',
              'MS PGothic',
              'MS Reference Sans Serif',
              'MS Sans Serif',
              'MS Serif',
              'MYRIAD',
              'MYRIAD PRO',
              'Palatino',
              'Palatino Linotype',
              'Segoe Print',
              'Segoe Script',
              'Segoe UI',
              'Segoe UI Light',
              'Segoe UI Semibold',
              'Segoe UI Symbol',
              'Tahoma',
              'Times',
              'Times New Roman',
              'Times New Roman PS',
              'Trebuchet MS',
              'Verdana',
              'Wingdings',
              'Wingdings 2',
              'Wingdings 3',
            ];

          r = r.filter(function(e, t) {
            return r.indexOf(e) === t;
          });

          let a = document.getElementsByTagName('body')[0],
            o = document.createElement('div'),
            s = document.createElement('div'),
            l = {},
            d = {},
            u = function() {
              var e = document.createElement('span');
              return (
                (e.style.position = 'absolute'),
                (e.style.left = '-9999px'),
                (e.style.fontSize = '72px'),
                (e.style.fontStyle = 'normal'),
                (e.style.fontWeight = 'normal'),
                (e.style.letterSpacing = 'normal'),
                (e.style.lineBreak = 'auto'),
                (e.style.lineHeight = 'normal'),
                (e.style.textTransform = 'none'),
                (e.style.textAlign = 'left'),
                (e.style.textDecoration = 'none'),
                (e.style.textShadow = 'none'),
                (e.style.whiteSpace = 'normal'),
                (e.style.wordBreak = 'normal'),
                (e.style.wordSpacing = 'normal'),
                (e.innerHTML = 'mmmmmmmmmmlli'),
                e
              );
            },
            c = function(e) {
              for (var t = !1, n = 0; n < i.length; n++)
                if (
                  (t =
                    e[n].offsetWidth !== l[i[n]] ||
                    e[n].offsetHeight !== d[i[n]])
                )
                  return t;
              return t;
            },
            h = (function() {
              for (var e = [], t = 0, n = i.length; t < n; t++) {
                var r = u();
                r.style.fontFamily = i[t];
                o.appendChild(r);
                e.push(r);
              }
              return e;
            })();

          a.appendChild(o);
          for (var p = 0, g = i.length; p < g; p++) {
            l[i[p]] = h[p].offsetWidth;
            d[i[p]] = h[p].offsetHeight;
          }

          var f = (function() {
            for (var e, t, n, a = {}, o = 0, l = r.length; o < l; o++) {
              for (var d = [], c = 0, h = i.length; c < h; c++) {
                var p =
                  ((e = r[o]),
                  (t = i[c]),
                  (n = void 0),
                  ((n = u()).style.fontFamily = "'" + e + "'," + t),
                  n);
                s.appendChild(p);
                d.push(p);
              }
              a[r[o]] = d;
            }
            return a;
          })();

          a.appendChild(s);
          for (var m = [], v = 0, y = r.length; v < y; v++)
            c(f[r[v]]) && m.push(r[v]);

          a.removeChild(s);

          a.removeChild(o);

          resolve(m);
        }, 1);
      });
    });

    addProcessor('audio_fp', function() {
      const SpecialFingerprint = {
        /** Making a fingerprint is skipped because the browser is known to always suspend audio context */
        KnownToSuspend: -1,
        /** The browser doesn't support audio context */
        NotSupported: -2,
        /** An unexpected timeout has happened */
        Timeout: -3,
      };

      const InnerErrorName = {
        Timeout: 'timeout',
        Suspended: 'suspended',
      };

      // Inspired by and based on https://github.com/cozylife/audio-fingerprint
      function getAudioFingerprint() {
        const AudioContext =
          w.OfflineAudioContext || w.webkitOfflineAudioContext;
        if (!AudioContext) {
          return SpecialFingerprint.NotSupported;
        }

        // In some browsers, audio context always stays suspended unless the context is started in response to a user action
        // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
        // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
        // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        if (doesCurrentBrowserSuspendAudioContext()) {
          return SpecialFingerprint.KnownToSuspend;
        }

        const context = new AudioContext(1, 44100, 44100);

        const oscillator = context.createOscillator();
        oscillator.type = 'triangle';
        setAudioParam(context, oscillator.frequency, 10000);

        const compressor = context.createDynamicsCompressor();
        setAudioParam(context, compressor.threshold, -50);
        setAudioParam(context, compressor.knee, 40);
        setAudioParam(context, compressor.ratio, 12);
        setAudioParam(context, compressor.reduction, -20);
        setAudioParam(context, compressor.attack, 0);
        setAudioParam(context, compressor.release, 0.25);

        oscillator.connect(compressor);
        compressor.connect(context.destination);
        oscillator.start(0);

        function disconnect() {
          try {
            oscillator.disconnect();
            compressor.disconnect();
          } catch (e) {}
        }

        return renderAudio(context).then(
          function(buffer) {
            disconnect();
            return getHash(buffer.getChannelData(0));
          },
          function(error) {
            disconnect();

            if (
              error.name === InnerErrorName.Timeout ||
              error.name === InnerErrorName.Suspended
            ) {
              return SpecialFingerprint.Timeout;
            }
            throw error;
          }
        );
      }

      /**
       * Checks if the current browser is known to always suspend audio context
       */
      function doesCurrentBrowserSuspendAudioContext() {
        function countTruthy(values) {
          return values.reduce((sum, value) => sum + (value ? 1 : 0), 0);
        }

        function isWebKit() {
          // Based on research in September 2020
          return (
            countTruthy([
              'ApplePayError' in w,
              'CSSPrimitiveValue' in w,
              'Counter' in w,
              n.vendor.indexOf('Apple') === 0,
              'getStorageUpdates' in n,
              'WebKitMediaKeys' in w,
            ]) >= 4
          );
        }

        function isDesktopSafari() {
          return (
            countTruthy([
              'safari' in w, // Always false in BrowserStack Automate
              !('DeviceMotionEvent' in w),
              !('ongestureend' in w),
              !('standalone' in n),
            ]) >= 3
          );
        }

        function isWebKit606OrNewer() {
          // Checked in Safari 9–14
          return (
            countTruthy([
              'DOMRectList' in w,
              'RTCPeerConnectionIceEvent' in w,
              'SVGGeometryElement' in w,
              'ontransitioncancel' in w,
            ]) >= 3
          );
        }

        return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
      }

      function setAudioParam(context, param, value) {
        const isAudioParam = (value) =>
          value && typeof value.setValueAtTime === 'function';

        if (isAudioParam(param)) {
          param.setValueAtTime(value, context.currentTime);
        }
      }

      function renderAudio(context) {
        const resumeTriesMaxCount = 3;
        const resumeRetryDelay = 500;
        const runningTimeout = 1000;

        return new Promise((resolve, reject) => {
          context.oncomplete = (event) => resolve(event.renderedBuffer);

          let resumeTriesLeft = resumeTriesMaxCount;

          const tryResume = () => {
            context.startRendering();

            switch (context.state) {
              case 'running':
                setTimeout(
                  () => reject(makeInnerError(InnerErrorName.Timeout)),
                  runningTimeout
                );
                break;

              // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
              // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
              // background on iPhone. Retries usually help in this case.
              case 'suspended':
                // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                // can be suspended when `document.hidden === false` and start running after a retry.
                if (!d.hidden) {
                  resumeTriesLeft--;
                }
                if (resumeTriesLeft > 0) {
                  setTimeout(tryResume, resumeRetryDelay);
                } else {
                  reject(makeInnerError(InnerErrorName.Suspended));
                }
                break;
            }
          };

          tryResume();
        });
      }

      function getHash(signal) {
        let hash = 0;
        for (let i = 4500; i < 5000; ++i) {
          hash += Math.abs(signal[i]);
        }
        return hash;
      }

      function makeInnerError(name) {
        const error = new Error(name);
        error.name = name;
        return error;
      }

      return getAudioFingerprint();
    });

    return processors;
  }

  const x64 = {
    x64Add: function(e, t) {
      (e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]),
        (t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]]);
      var n = [0, 0, 0, 0];
      return (
        (n[3] += e[3] + t[3]),
        (n[2] += n[3] >>> 16),
        (n[3] &= 65535),
        (n[2] += e[2] + t[2]),
        (n[1] += n[2] >>> 16),
        (n[2] &= 65535),
        (n[1] += e[1] + t[1]),
        (n[0] += n[1] >>> 16),
        (n[1] &= 65535),
        (n[0] += e[0] + t[0]),
        (n[0] &= 65535),
        [(n[0] << 16) | n[1], (n[2] << 16) | n[3]]
      );
    },
    x64Multiply: function(e, t) {
      (e = [e[0] >>> 16, 65535 & e[0], e[1] >>> 16, 65535 & e[1]]),
        (t = [t[0] >>> 16, 65535 & t[0], t[1] >>> 16, 65535 & t[1]]);
      var n = [0, 0, 0, 0];
      return (
        (n[3] += e[3] * t[3]),
        (n[2] += n[3] >>> 16),
        (n[3] &= 65535),
        (n[2] += e[2] * t[3]),
        (n[1] += n[2] >>> 16),
        (n[2] &= 65535),
        (n[2] += e[3] * t[2]),
        (n[1] += n[2] >>> 16),
        (n[2] &= 65535),
        (n[1] += e[1] * t[3]),
        (n[0] += n[1] >>> 16),
        (n[1] &= 65535),
        (n[1] += e[2] * t[2]),
        (n[0] += n[1] >>> 16),
        (n[1] &= 65535),
        (n[1] += e[3] * t[1]),
        (n[0] += n[1] >>> 16),
        (n[1] &= 65535),
        (n[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0]),
        (n[0] &= 65535),
        [(n[0] << 16) | n[1], (n[2] << 16) | n[3]]
      );
    },
    x64Rotl: function(e, t) {
      return 32 == (t %= 64)
        ? [e[1], e[0]]
        : t < 32
        ? [(e[0] << t) | (e[1] >>> (32 - t)), (e[1] << t) | (e[0] >>> (32 - t))]
        : ((t -= 32),
          [
            (e[1] << t) | (e[0] >>> (32 - t)),
            (e[0] << t) | (e[1] >>> (32 - t)),
          ]);
    },
    x64LeftShift: function(e, t) {
      return 0 == (t %= 64)
        ? e
        : t < 32
        ? [(e[0] << t) | (e[1] >>> (32 - t)), e[1] << t]
        : [e[1] << (t - 32), 0];
    },
    x64Xor: function(e, t) {
      return [e[0] ^ t[0], e[1] ^ t[1]];
    },
    x64Fmix: function(e) {
      return (
        (e = this.x64Xor(e, [0, e[0] >>> 1])),
        (e = this.x64Multiply(e, [4283543511, 3981806797])),
        (e = this.x64Xor(e, [0, e[0] >>> 1])),
        (e = this.x64Multiply(e, [3301882366, 444984403])),
        this.x64Xor(e, [0, e[0] >>> 1])
      );
    },
    x64hash128: function(e, t) {
      t = t || 0;
      for (
        var n = (e = e || '').length % 16,
          i = e.length - n,
          r = [0, t],
          a = [0, t],
          o = [0, 0],
          s = [0, 0],
          l = [2277735313, 289559509],
          d = [1291169091, 658871167],
          u = 0;
        u < i;
        u += 16
      )
        (o = [
          (255 & e.charCodeAt(u + 4)) |
            ((255 & e.charCodeAt(u + 5)) << 8) |
            ((255 & e.charCodeAt(u + 6)) << 16) |
            ((255 & e.charCodeAt(u + 7)) << 24),
          (255 & e.charCodeAt(u)) |
            ((255 & e.charCodeAt(u + 1)) << 8) |
            ((255 & e.charCodeAt(u + 2)) << 16) |
            ((255 & e.charCodeAt(u + 3)) << 24),
        ]),
          (s = [
            (255 & e.charCodeAt(u + 12)) |
              ((255 & e.charCodeAt(u + 13)) << 8) |
              ((255 & e.charCodeAt(u + 14)) << 16) |
              ((255 & e.charCodeAt(u + 15)) << 24),
            (255 & e.charCodeAt(u + 8)) |
              ((255 & e.charCodeAt(u + 9)) << 8) |
              ((255 & e.charCodeAt(u + 10)) << 16) |
              ((255 & e.charCodeAt(u + 11)) << 24),
          ]),
          (o = this.x64Multiply(o, l)),
          (o = this.x64Rotl(o, 31)),
          (o = this.x64Multiply(o, d)),
          (r = this.x64Xor(r, o)),
          (r = this.x64Rotl(r, 27)),
          (r = this.x64Add(r, a)),
          (r = this.x64Add(this.x64Multiply(r, [0, 5]), [0, 1390208809])),
          (s = this.x64Multiply(s, d)),
          (s = this.x64Rotl(s, 33)),
          (s = this.x64Multiply(s, l)),
          (a = this.x64Xor(a, s)),
          (a = this.x64Rotl(a, 31)),
          (a = this.x64Add(a, r)),
          (a = this.x64Add(this.x64Multiply(a, [0, 5]), [0, 944331445]));
      switch (((o = [0, 0]), (s = [0, 0]), n)) {
        case 15:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 14)], 48));
        case 14:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 13)], 40));
        case 13:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 12)], 32));
        case 12:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 11)], 24));
        case 11:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 10)], 16));
        case 10:
          s = this.x64Xor(s, this.x64LeftShift([0, e.charCodeAt(u + 9)], 8));
        case 9:
          (s = this.x64Xor(s, [0, e.charCodeAt(u + 8)])),
            (s = this.x64Multiply(s, d)),
            (s = this.x64Rotl(s, 33)),
            (s = this.x64Multiply(s, l)),
            (a = this.x64Xor(a, s));
        case 8:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 7)], 56));
        case 7:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 6)], 48));
        case 6:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 5)], 40));
        case 5:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 4)], 32));
        case 4:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 3)], 24));
        case 3:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 2)], 16));
        case 2:
          o = this.x64Xor(o, this.x64LeftShift([0, e.charCodeAt(u + 1)], 8));
        case 1:
          (o = this.x64Xor(o, [0, e.charCodeAt(u)])),
            (o = this.x64Multiply(o, l)),
            (o = this.x64Rotl(o, 31)),
            (o = this.x64Multiply(o, d)),
            (r = this.x64Xor(r, o));
      }
      return (
        (r = this.x64Xor(r, [0, e.length])),
        (a = this.x64Xor(a, [0, e.length])),
        (r = this.x64Add(r, a)),
        (a = this.x64Add(a, r)),
        (r = this.x64Fmix(r)),
        (a = this.x64Fmix(a)),
        (r = this.x64Add(r, a)),
        (a = this.x64Add(a, r)),
        ('00000000' + (r[0] >>> 0).toString(16)).slice(-8) +
          ('00000000' + (r[1] >>> 0).toString(16)).slice(-8) +
          ('00000000' + (a[0] >>> 0).toString(16)).slice(-8) +
          ('00000000' + (a[1] >>> 0).toString(16)).slice(-8)
      );
    },
  };

  function makeFingerprintHash(data) {
    const a = data.map((item) => {
      const value = item.value;

      if (value != null && typeof value.join === 'function') {
        return value.join(';');
      }

      return value;
    });

    return x64.x64hash128(a.join('~~~'), 31);
  }

  function init() {
    const processors = getProcessors();

    const futureValues = processors.map((p) => p.handler());

    return Promise.all(futureValues).then((values) => {
      const result = values.map((value, index) => {
        return {
          key: processors[index].key,
          value: value,
        };
      });

      result.push({
        key: 'fingerprint_hash',
        value: makeFingerprintHash(result),
      });

      return result;
    });
  }

  return init();
}

export async function loadFingerprint() {
  const fingerprint = await makeFingerprint();
  return arrayToObject(fingerprint);
}
